import { useQuery } from 'react-query';

import useAPIQuery from '../api/useAPIQuery';
import useInfiniteAPIQuery from '../api/useInfiniteAPIQuery';
import usePrefetchPages from '../hooks/usePrefetchPages';
import { PermissionCollection } from '../types';

const usePermissionCheckerQuery = (
  requiredPermissions: PermissionCollection['codename'][],
  operation: 'and' | 'or' = 'and'
) => {
  const user = useAPIQuery('/users/me/');
  const permissionsPages = useInfiniteAPIQuery(
    ['/permissions/', { params: { group__user: user.data?.id } }],
    {
      enabled: user.isSuccess,
    }
  );
  const permissions = usePrefetchPages(permissionsPages, (data) => data.results);

  const result = useQuery<boolean>(['permission-checker', requiredPermissions], {
    queryFn: async () => {
      if (user.data?.is_staff) {
        return true;
      }

      if (permissions.length === 0) {
        return false;
      }

      const grantedPermissions = permissions.map((permission) => permission.codename) ?? [];

      if (operation === 'or') {
        return requiredPermissions.some((requiredPermission) =>
          grantedPermissions.includes(requiredPermission)
        );
      } else {
        return requiredPermissions.every((requiredPermission) =>
          grantedPermissions.includes(requiredPermission)
        );
      }
    },
    enabled: user.isSuccess && permissionsPages.isSuccess,
  });

  return result;
};

export default usePermissionCheckerQuery;
